/**
 * Centralized Configuration for CollectoHub
 */

const getApiUrl = () => {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const isAndroidEmulator = hostname === "10.0.2.2" || hostname === "10.0.3.2";
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1" || isAndroidEmulator;
  const isPrimaryCollectoHost =
    hostname === "collectohub.com" || hostname === "www.collectohub.com";
  const useSameOriginApi = import.meta.env.VITE_USE_SAME_ORIGIN_API === "true";

  // Force local API if running on localhost to avoid stale build/env issues
  if (isLocal) return isAndroidEmulator ? `https://${hostname}:7169` : "https://localhost:7169";

  // On the primary public web hosts, prefer same-origin `/api` requests.
  // This avoids browser-side QUIC / CORS failures when the dedicated API
  // subdomain is reachable inconsistently through the CDN or reverse proxy.
  if ((useSameOriginApi || isPrimaryCollectoHost) && typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }

  // 1. Check environment variable for production/other environments
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL;

  // 2. Default Live URL
  return "https://api.collectohub.com";
};


export const APP_CONFIG = {
  API_URL: getApiUrl(),
  API_BASE: `${getApiUrl()}/api`,
  APP_TITLE: "CollectoHub",
  DEV_TITLE: "CollectoHub (Dev)",

  STORAGE_KEYS: {
    TOKEN: "collectohub-auth-token",
    REFRESH: "collectohub-refresh-token",
    COLOR_MODE: "colorMode",
  },

  NOTIFICATIONS: {
    ANCHOR: { vertical: "top" as const, horizontal: "right" as const },
    FIREBASE_VAPID_KEY: import.meta.env.VITE_FIREBASE_VAPID_KEY || "",
    DURATION: {
      SUCCESS: 3000,
      ERROR: 4000,
      INFO: 5000
    }
  },

  PAGINATION: {
    DEFAULT_PAGE_SIZE: 24,
    MAINTENANCE_PAGE_SIZE: 20
  },

  DEFAULT_IMAGES: {
    USER: "/Image/userimage/userimage.jpg",
    MODEL: "/images/default-model.png",
  },

  THEME: {
    PRIMARY: "#3699FF",
    SECONDARY: "#1E1E2D",
    SUCCESS: "#1BC5BD",
    DANGER: "#F64E60",
  },

  Z_INDEX: {
    MOBILE_NAV: 10000,
  },

  FALLBACKS: {
    ROLE: "Üye",
    BRAND: "Markasız",
    BRAND_FOLDER: "HotWheels",
  }
};
